import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { createAdminGroupChatThread } from '../../../api/adminGroupChat';
import EventDerivedGroupModal from './EventDerivedGroupModal';

export type EventDerivedGroupLauncherHandle = { open: () => void };

type Props = {
  eventId?: string;
  eventName?: string;
  artists: React.ComponentProps<typeof EventDerivedGroupModal>['artists'];
  navigate: (path: string) => void;
  onSuccess: (message: string) => void;
  onError: (message: string) => void;
};

const EventDerivedGroupLauncher = forwardRef<EventDerivedGroupLauncherHandle, Props>(function EventDerivedGroupLauncher(
  { eventId, eventName, artists, navigate, onSuccess, onError },
  ref
) {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  useImperativeHandle(ref, () => ({ open: () => setOpen(true) }), []);

  const create = async ({ title, artistIds }: { title: string; artistIds: string[] }) => {
    if (!eventId || saving) return;
    setSaving(true);
    try {
      const payload = await createAdminGroupChatThread({
        title, mode: 'manual', artistIds, linkedEventUuid: eventId,
      });
      const threadId = String(payload?.thread?.thread_id || '').trim();
      setOpen(false);
      onSuccess('イベントに連動するグループチャットを作成しました。');
      if (threadId) navigate(`/admin/workspaces/communications/group-chat?thread=${encodeURIComponent(threadId)}`);
    } catch (error) {
      onError(error instanceof Error ? error.message : 'グループチャットの作成に失敗しました。');
    } finally {
      setSaving(false);
    }
  };

  return (
    <EventDerivedGroupModal
      open={open} eventName={eventName} artists={artists} saving={saving}
      onClose={() => setOpen(false)} onCreate={create}
    />
  );
});

export default EventDerivedGroupLauncher;
